import React from 'react';
import '../styles/footer.css';
import FacebookIcon from '@mui/icons-material/Facebook';
import InstagramIcon from '@mui/icons-material/Instagram';
import HomeIcon from '@mui/icons-material/Home';
import { useLanguage } from '../context/LanguageContext';

const Footer = () => {
  const { language } = useLanguage();

  const content = {
    es: {
      slogan: 'Nutricion consciente desde Loja, Ecuador.',
      home: 'Inicio',
      contact: 'Contactanos'
    },
    en: {
      slogan: 'Conscious nutrition from Loja, Ecuador.',
      home: 'Home',
      contact: 'Contact us'
    }
  };

  const t = content[language];

  return (
    <footer className="footer">
      <div className="footer-section footer-left">
        <p className="footer-brand">SAINZA</p>
        <p className="footer-text">{t.slogan}</p>
      </div>
      <div className="footer-section footer-center">
        <a href="https://www.facebook.com/sainza.altonangaritza/" target="_blank" rel="noopener noreferrer">
          <FacebookIcon className="footer-icon" />
          <span>Facebook</span>
        </a>
        <a href="https://www.instagram.com/sainza.altonangaritza/" target="_blank" rel="noopener noreferrer">
          <InstagramIcon className="footer-icon" />
          <span>Instagram</span>
        </a>
        <a href="/inicio" rel="noopener noreferrer">
          <HomeIcon className="footer-icon" />
          <span>{t.home}</span>
        </a>
      </div>
      <div className="footer-section footer-right">
        <a href="/contacto"><span>{t.contact}</span></a>
        <p>© 2026 SAINZA</p>
      </div>
    </footer>
  );
};

export default Footer;
